/**
 * Mapping of column id as key and API sort value as value
 *
 * Note: column id is generated in src/App/Recordings/recordings.selectors.js in tableFormColumns method
 *   id: `${column.category}_${column.key}`,
 */
export default {
  contact_fields_id: 'id',
  contact_fields_ani: 'ani',
  contact_fields_dnis: 'dnis',
  contact_fields_quality_reason: 'reason',
  contact_fields_call_duration: 'callDuration',
  contact_fields_hr: 'hr',
  contact_fields_training: 'training',
  contact_fields_evaluation_state: 'evaluation.stateId',
  contact_fields_to_address: 'to_address',
  contact_fields_from_address: 'from_address',
  contact_fields_end_of_call_workflow_rule: 'end_of_call_workflow_rule',
  contact_fields_daily_workflow_rule: 'daily_workflow_rule',
  contact_fields_subject: 'subject',
  contact_fields_contact_type: 'contactType',
  contact_fields_recording_type: 'recordingType',
  contact_fields_retention_policy: 'retention_policy',
  contact_fields_surveyScore: 'surveyScore',
  contact_fields_surveyName: 'surveyName',
  contact_fields_assocCallId: 'assocCallId',
  contact_fields_audioFileUploadStateId: 'audioDisplayStateId',
  contact_fields_videoFileUploadStateId: 'screenDisplayStateId',
  contact_fields_direction: 'direction',
  contact_fields_external_party: 'externalParty',
  contact_fields_text_preview: 'textPreview',
  contact_fields_channel: 'channel',


  date_fields_date: 'startTime',
  date_fields_time: 'startTime',
  date_fields_tz: 'tz',

  organization_fields_agent_acd_id: 'agent.agentAcdId',
  organization_fields_last_name: 'agent.lastName',
  organization_fields_first_name: 'agent.firstName',
  organization_fields_group_name: 'group.name',
  organization_fields_team_name: 'team.name',

  evaluation_fields_evaluation_score: 'evaluation.totalScore',
  evaluation_fields_evaluator_name: 'evaluatorName',
  evaluation_fields_evaluation_date: 'evaluation.evaluated',
  evaluation_fields_approved_by: 'approver.lastName',
  evaluation_fields_evaluation_form_name: 'evalForm.name',
  evaluation_fields_evaluation_calibration: 'isCalibration',
  evaluation_fields_eval_response_date: 'eval_response_date',
  evaluation_fields_eval_response_state: 'eval_response_state',

  caa_fields_eval_score_prediction: 'peval',
  caa_fields_net_promoter_score_prediction: 'pnps',
  caa_fields_sentiment: 'sentiment',

  analysis_fields_silence_max_duration: 'eventCalculations.silence.maxDuration',
  analysis_fields_silence_min_duration: 'eventCalculations.silence.minDuration',
  analysis_fields_silence_average_duration: 'eventCalculations.silence.avgDuration',
  analysis_fields_silence_total_duration: 'eventCalculations.silence.totalDuration',
  analysis_fields_silence_total_events: 'eventCalculations.silence.totalEvents',
  analysis_fields_silence_percent_of_call: 'eventCalculations.silence.percentOfCall',
  analysis_fields_talkover_max_duration: 'eventCalculations.talkover.maxDuration',
  analysis_fields_talkover_min_duration: 'eventCalculations.talkover.minDuration',
  analysis_fields_talkover_average_duration: 'eventCalculations.talkover.avgDuration',
  analysis_fields_talkover_total_duration: 'eventCalculations.talkover.totalDuration',
  analysis_fields_talkover_total_events: 'eventCalculations.talkover.totalEvents',
  analysis_fields_talkover_percent_of_call: 'eventCalculations.talkover.percentOfCall',
  analysis_fields_pause_max_duration: 'eventCalculations.pause.maxDuration',
  analysis_fields_pause_min_duration: 'eventCalculations.pause.minDuration',
  analysis_fields_pause_average_duration: 'eventCalculations.pause.avgDuration',
  analysis_fields_pause_total_duration: 'eventCalculations.pause.totalDuration',
  analysis_fields_pause_total_events: 'eventCalculations.pause.totalEvents',
  analysis_fields_pause_percent_of_call: 'eventCalculations.pause.percentOfCall',
  analysis_fields_hold_max_duration: 'eventCalculations.hold.maxDuration',
  analysis_fields_hold_min_duration: 'eventCalculations.hold.minDuration',
  analysis_fields_hold_average_duration: 'eventCalculations.hold.avgDuration',
  analysis_fields_hold_total_duration: 'eventCalculations.hold.totalDuration',
  analysis_fields_hold_total_events: 'eventCalculations.hold.totalEvents',
  analysis_fields_hold_percent_of_call: 'eventCalculations.hold.percentOfCall',

  contact_fields_reason: 'reason', // might not exist anymore
  contact_fields_line: 'line', // might not exist anymore
  caa_fields_net_promoter_score: 'net_promoter_score', // might not exist anymore
} as const
